import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { ModalComponent } from '../../../core/config/core.modal-helpers';

@Component({
  selector: 'wiki-edit-help-modal',
  template: require('./wiki.edit-help.modal.html'),
  styles: [`
    :host { display: block; }
    :host ::ng-deep .wiki-help-modal { display: flex; flex-direction: column; max-height: calc(100vh - 120px); }
    :host ::ng-deep .wiki-help-modal .modal-header,
    :host ::ng-deep .wiki-help-modal .modal-footer { flex: 0 0 auto; }
    :host ::ng-deep .wiki-help-modal .wiki-help-modal-body {
      flex: 1 1 auto;
      overflow-y: auto;
      min-height: 0;
    }
    :host ::ng-deep .wiki-help-modal .wiki-help-modal-body h4 { margin-top: 1.2em; }
    :host ::ng-deep .wiki-help-modal .wiki-help-modal-body h4:first-child { margin-top: 0; }
    :host ::ng-deep .wiki-help-modal .wiki-help-modal-body pre {
      background: #f7f9fc;
      border: 1px solid #ebedf2;
      border-radius: 4px;
      padding: 8px 10px;
      font-size: 12px;
    }
    :host ::ng-deep .wiki-help-modal .wiki-help-external { margin-top: 1.5em; }
  `]
})
export class WikiEditHelpModalComponent extends ModalComponent implements OnInit {
  @Output() onClose = new EventEmitter<any>();

  constructor() {
    super();
  }

  ngOnInit() {}

  closeModal() {
    this.onClose.emit();
  }
}
